import { Controller } from "@hotwired/stimulus"

// The search over the quick-action picker (assistants/_quick_actions_picker):
// rows match on their name, prompt and group (data-search), a group with no
// match hides, and "Nothing matches" shows when nothing does. A frame reload
// after adding one keeps what was typed.
export default class extends Controller {
    static targets = ["query", "row", "group", "empty"]

    connect() {
        const kept = this.element.closest("turbo-frame")?.dataset.query
        if (kept && this.hasQueryTarget) {
            this.queryTarget.value = kept
            this.filter()
        }
    }

    filter() {
        const words = this.queryTarget.value.toLowerCase().split(/\s+/).filter(Boolean)
        const frame = this.element.closest("turbo-frame")
        if (frame) frame.dataset.query = this.queryTarget.value
        this.rowTargets.forEach((row) => {
            const text = row.dataset.search || ""
            row.hidden = !words.every((word) => text.includes(word))
        })
        let any = false
        this.groupTargets.forEach((group) => {
            const shown = group.querySelector("[data-quick-action-picker-target=row]:not([hidden])")
            group.hidden = !shown
            if (shown) any = true
        })
        if (this.hasEmptyTarget) this.emptyTarget.hidden = any || words.length === 0
    }
}
